

const useRandomSamplerDropDownController = (changeOption) => {

    const handleChange = (event) => {
        changeOption(event.target.value);
    };


    return {handleChange};

};

export default useRandomSamplerDropDownController;
